import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgNotificationsSelectedNavIconSecondary from './svgs/NotificationsSelectedNavIconSecondary.js';
import SvgNotificationsSelectedNavIcon from './svgs/NotificationsSelectedNavIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var notificationsSelectedNavIcon = (props => useIcon(SvgNotificationsSelectedNavIcon, SvgNotificationsSelectedNavIconSecondary, props));

export { notificationsSelectedNavIcon as default };
